import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getRoleName } from "../../components/Utils";
import SearchOverlay from "./SearchOverlay";
import NavbarClock from "./NavbarClock";
import "./Navbar.css";

const NavBar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const auth_user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openDrawer = () => {
    document.body.classList.add("sidebar-open");
  };

  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuActive((prev) => !prev);
  };

  const closeMenu = () => setMenuActive(false);

  const logout = () => {
    closeMenu();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <nav className="navbar header-nav-bar py-3 px-4" id="layout-navbar">
      <div className="header-container">
        <div className="header-left">
          <div
            onClick={openDrawer}
            id="menu-toggle"
            className="layout-menu-toggle d-xl-none"
          >
            <i className="bx bx-menu bx-sm"></i>
          </div>

          {/* Search Bar - click to open overlay */}
          <div
            className={`search-bar glass-panel d-flex align-items-center ${searchOpen ? "active" : ""}`}
            onClick={() => setSearchOpen(true)}
            role="button"
            tabIndex={0}
            title="Click to search (Ctrl+K)"
          >
            <i className="fa-solid fa-magnifying-glass"></i>
            <span className="search-placeholder-text ms-3">Search pages...</span>
          </div>
        </div>

        <div className="header-center d-none d-lg-flex">
          <NavbarClock />
        </div>

        {/* User Profile */}
        <div className="header-right position-relative" ref={dropdownRef}>
          <div
            className={`admin-profile-trigger d-flex align-items-center ${menuActive ? "active" : ""}`}
            onClick={toggleMenu}
            role="button"
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={menuActive}
          >
            {auth_user?.name && (
              <div className="text-end me-3 d-none d-sm-block">
                <div className="navbar-user-greeting">Hi, {auth_user.name}</div>
                <div className="navbar-user-role">
                  {getRoleName(auth_user?.user_type)}
                </div>
              </div>
            )}
            <div className="profile-avatar-circle text-white d-flex justify-content-center align-items-center shadow-sm">
              <i className="fa-solid fa-user"></i>
            </div>
            <i className="fa-solid fa-chevron-down ms-2 admin-chevron"></i>
          </div>

          <div className={`admin-profile-dropdown ${menuActive ? "show" : ""}`}>
            <div className="admin-dropdown-user-box">
              <div className="admin-box-avatar">
                <i className="fa-solid fa-user"></i>
              </div>
              <div className="admin-box-info">
                <div className="admin-box-name">{auth_user?.name}</div>
                <div className="admin-box-email">{auth_user?.email}</div>
                <div className="admin-box-role">
                  <i className="fa-solid fa-crown"></i>
                  <span>{getRoleName(auth_user?.user_type)}</span>
                </div>
              </div>
            </div>

            <div className="admin-dropdown-menu">
              <Link
                to="change-password"
                className="admin-dropdown-item"
                onClick={closeMenu}
              >
                <i className="fa-regular fa-circle-user admin-item-icon"></i>
                <span>Change Password</span>
              </Link>
            </div>

            <a
              href="#"
              className="admin-dropdown-logout"
              onClick={(e) => {
                e.preventDefault();
                logout();
              }}
            >
              <i className="fa-solid fa-arrow-right-from-bracket"></i>
              <span>Logout</span>
            </a>
          </div>
        </div>
      </div>

      {/* Search Overlay */}
      <SearchOverlay isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
    </nav>
  );
};

export default NavBar;
